import { styled } from '@mui/system';
import MuiInputBase from '@mui/material/InputBase';
import { black, blue, greyBorder, darkBlue, lightGrey, white } from '@cpg-its/ads.constants.colors';
export const StyledInputBaseComponent = styled(MuiInputBase)({
    backgroundColor: white,
    border: `1px solid ${greyBorder}`,
    borderRadius: '3px',
    fontSize: '0.875rem',
    height: '2.5rem',
    '&:hover': {
        border: `1px solid ${blue}`,
    },
    '&.Mui-disabled': {
        backgroundColor: lightGrey,
        border: `1px solid ${black}`,
        '& input': {
            border: 'none',
            color: black,
            WebkitTextFillColor: black,
        },
    },
    '&.Mui-focused': {
        outline: 'none',
        border: `1px solid ${darkBlue}`,
    },
    '& input, select, textarea': {
        borderRadius: '3px',
        border: '1px solid transparent',
        height: 'calc(100% - 4px)',
        margin: '1px',
        padding: '0 5px',
        '&:focus': {
            border: `1px solid ${darkBlue}`,
        },
        '&[type=number]': {
            MozAppearance: 'textfield',
        },
        '&::-webkit-outer-spin-button': {
            WebkitAppearance: 'none',
            margin: 0,
        },
        '&::-webkit-inner-spin-button': {
            WebkitAppearance: 'none',
            margin: 0,
        },
    },
    '& textarea': {
        padding: '7px',
    },
    '&.MuiInputBase-multiline': {
        height: 'inherit',
        padding: 0,
    },
});
export default StyledInputBaseComponent;
//# sourceMappingURL=custom-input-base.js.map